export const LINE_ITEM_NAME_COLUMN_ID = 'lineItemName';

export const LINE_ITEM_START_DATE_COLUMN_ID = 'lineItemStartDate';

export const LINE_ITEM_END_DATE_COLUMN_ID = 'lineItemEndDate';
